export default class Log {
    public log_id: number | null = null;
    public timestamp: string | null = null;
    public priority: number | null = null;
    public priorityname: string | null = null;
    public message: string | null = null;
    public extra_ip: string | null = null;
    public extra_user_id: number | null = null;
    public extra_errno: number | null = null;
    public extra_file: string | null = null;
    public extra_line: number | null = null;
    public extra_trace: string | null = null;
    public extra_function: string | null = null;
    public extra_xdebug: string | null = null;
    public extra_class: string | null = null;

    constructor(data?: Partial<Log>) {
        Object.assign(this, data);
    }
}
